import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Ceyan = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 20 20"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="c73c8__a">
              <rect
                rx="0"
                height="20"
                width="20"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#c73c8__a)"
            fill="#00CC36"
          >
            <path
              d="M13.75 5.417q0 .184-.018.367-.018.184-.054.364-.036.18-.09.357-.053.177-.123.347-.07.17-.158.332-.087.163-.189.316-.102.153-.22.296-.116.142-.246.272-.13.13-.273.247-.142.117-.296.22-.153.102-.315.189-.163.087-.333.157t-.346.124q-.177.054-.357.09-.181.036-.364.054-.184.018-.368.018t-.368-.018q-.183-.018-.364-.054-.18-.036-.357-.09-.176-.053-.346-.124-.17-.07-.333-.157-.162-.087-.315-.19-.154-.102-.296-.219-.142-.116-.273-.247-.13-.13-.247-.272-.117-.143-.219-.296t-.19-.316q-.086-.162-.157-.332-.07-.17-.124-.347-.053-.176-.089-.357-.036-.18-.054-.364-.018-.183-.018-.367 0-.185.018-.368t.054-.364q.036-.18.09-.357.053-.176.123-.346.071-.17.158-.333.087-.163.189-.316.102-.153.22-.295.116-.143.246-.273.13-.13.273-.247.142-.117.296-.22.153-.102.315-.189.163-.086.333-.157.17-.07.346-.124.177-.053.357-.09.181-.035.364-.053.184-.018.368-.018t.368.018q.183.018.364.054.18.036.357.09.176.053.346.123.17.07.333.157.162.087.315.19.154.102.296.219t.273.247q.13.13.247.273.117.142.219.295t.19.316q.086.162.157.333.07.17.124.346.053.176.089.357.036.18.054.364.018.183.018.368Z"
              data-follow-fill="#00CC36"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M13.094 8.51q1.281-1.281 1.281-3.093 0-1.813-1.281-3.094Q11.812 1.042 10 1.042q-1.812 0-3.094 1.281-1.281 1.281-1.281 3.094 0 1.812 1.281 3.093Q8.188 9.792 10 9.792q1.812 0 3.094-1.282Zm-.884-5.303q.915.915.915 2.21 0 1.294-.915 2.21-.916.915-2.21.915t-2.21-.916q-.915-.915-.915-2.21 0-1.294.915-2.21.916-.914 2.21-.914t2.21.915Z"
              data-follow-fill="#00CC36"
              fill={_fill}
            />
            <path
              d="M2.083 18.333c0-3.515 2.573-6.797 4.75-7.5q1.98 2.11 3.167 3.516l3.167-3.516c1.781.235 4.75 3.985 4.75 7.5"
              data-follow-fill="#00CC36"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M15.694 13.706q1.598 2.329 1.598 4.627h1.25q0-2.686-1.817-5.334-.776-1.131-1.665-1.87-.968-.804-1.812-.915a.625.625 0 0 0-.546.201l-2.69 2.987q-1.097-1.264-2.723-2.996a.625.625 0 0 0-.648-.167q-1.947.629-3.516 2.938-1.667 2.454-1.667 5.156h1.25q0-2.317 1.451-4.453 1.17-1.723 2.504-2.314 1.77 1.895 2.86 3.186a.624.624 0 0 0 .941.015l2.915-3.236q.389.15.882.56.755.627 1.433 1.615Z"
              data-follow-fill="#00CC36"
              fill={_fill}
            />
            <path
              fillRule="evenodd"
              d="M.833 18.958h18.334a.625.625 0 1 0 0-1.25H.833a.625.625 0 1 0 0 1.25Z"
              data-follow-fill="#00CC36"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
